import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { guideAppliesTo, guidesRegistry } from '../../data/guides/guidesRegistry';
import GuideTiles from '../GuideTiles/GuideTiles';
import { productSlug } from '../../hooks/useProducts';
import { isWatchfaceProduct } from '../../utils/productType';
/** Nur die Anleitungen, die für dieses Produkt gelten, nach Aufgabe gruppiert. */
const GuidesTab = ({ product }) => {
    const { t } = useTranslation();
    const slug = productSlug(product);
    const isWatchface = isWatchfaceProduct(product.is_vx);
    const guides = guidesRegistry.filter((g) => guideAppliesTo(g, slug, isWatchface));
    return (_jsxs("div", { className: "product-guides", children: [_jsx("p", { className: "product-tab-intro", children: t('pages.product.guidesIntro', { name: product.name }) }), _jsx(GuideTiles, { guides: guides, showDescription: false }), _jsx("p", { className: "product-guides-all", children: _jsx(Link, { to: "/help", className: "inline-link", children: t('pages.product.allGuides') }) })] }));
};
export default GuidesTab;
